import GridCell from "../GridCell/GridCell";
import { ReactNode } from "react";

interface GridRowProps {
  children: ReactNode | ReactNode[];
  gridRow?: undefined | "min-content" | "1fr";
}

const GridPresetList = ({ children }: GridRowProps) => (
  <GridCell
    startColsDesktop={2}
    spanColsDesktop={7}
    startColsTablet={1}
    spanColsTablet={6}
    startColsMobile={1}
    spanColsMobile={6}
  >
    {children}
  </GridCell>
);

export default GridPresetList;
